import { render, staticRenderFns } from "./AuthQuick.vue?vue&type=template&id=195e0c3b"
import script from "./AuthQuick.vue?vue&type=script&lang=js"
export * from "./AuthQuick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports